import * as React from 'react';
import {DashboardSolution} from "data/entities/DashboardSolution";
import {DateTimeHelpers} from "shared/DateTimeHelpers";
import {DateTime} from "luxon";

import './BadgeCard.pcss';

interface Props {
  solution:DashboardSolution;
}

export const BadgeCard = (props:Props) => {

  const whenAchievedDisplay =  DateTimeHelpers.parseDateTimeOr(props.solution.badgeEarnedDate, DateTime.now()).toFormat("LLLL yyyy");

  // //const whenAchieved = props.solution.badgeEarnedDate ? props.solution.badgeEarnedDate : new Date();
  // try {
  //   //whenAchievedDisplay = moment(whenAchieved).format("MMMM yyyy");
  //   const dt = DateTimeHelpers.parseDateTime(props.solution.badgeEarnedDate, DateTime.now());
  //   whenAchievedDisplay = dt.toFormat("LLLL yyyy");
  // } catch (e) {
  //   console.log(e);
  //   return null;
  // }

  return(
    <div className={"badgeCard"}>
      <div className={"solution-badge"}><img src={props.solution.badge} alt={`Badge of type ${props.solution.badgeType.label}`}/></div>
      <div className={"solution-badge-info"}>
        <h3>{props.solution.name}</h3>
        <p className={"date"}>{whenAchievedDisplay}</p>
        <p>{props.solution.points} points</p>
      </div>
    </div>
  );
}

